export const APNG = 'image/apng';
export const AVIF = 'image/avif';
export const GIF = 'image/gif';
export const JPEG = 'image/jpeg';
export const PNG = 'image/png';
export const SVG_XML = 'image/svg+xml';
export const WEBP = 'image/webp';

export const FILES = [APNG, AVIF, GIF, JPEG, PNG, SVG_XML, WEBP];
